import type { ReplaceRule } from '../types.js';

/**
 * 词义扩展规则
 * 对称呼词义进行扩展
 */
export const replaceRules: ReplaceRule[] = [
  {
    exp: /^从表/,
    arr: ['从父姑表', '从父舅表', '从父姨表', '从母姑表', '从母舅表', '从母叔表'],
  },
  {
    exp: /^表表/,
    arr: ['姑表叔表', '姑表姑表', '姑表舅表', '姑表姨表', '舅表叔表', '舅表姑表', '舅表舅表', '舅表姨表'],
  },
  {
    exp: /^([夫妻内外]?)表/,
    arr: ['$1姑表', '$1舅表'],
  },
  {
    exp: /^([姑舅])表(?=[^伯叔])/,
    arr: ['$1表伯', '$1表叔'],
  },
  {
    exp: /^姻/,
    arr: ['姑姻', '姨姻', '姊妹姻', '女姻'],
  },
  {
    exp: /^眷/,
    arr: ['叔眷', '舅眷', '兄弟眷', '男眷'],
  },
  {
    exp: /^亲家/,
    arr: ['姊妹姻', '兄弟眷'],
  },
  {
    exp: /^([堂表姨]?)([曾高天烈太远鼻]?)(祖?)([伯叔姑舅姨])/,
    arr: ['$1$4$2$3'],
  },
  {
    exp: /^([曾高天烈太远鼻]?)祖?王姑/,
    arr: ['姑$1祖母'],
  },
  {
    exp: /^([曾玄元来晜仍云耳])([侄甥])/,
    arr: ['$2$1'],
  },
  {
    exp: /^外表([伯叔姑舅姨])/,
    arr: ['姑表$1外', '舅表$1外'],
  },
  {
    exp: /([堂表姨]?)外甥/,
    arr: ['$1甥'],
  },
  {
    exp: /^([舅叔])([曾玄外]*)孙/,
    arr: ['$1侄$2孙'],
  },
  {
    exp: /^([姨姑])([曾玄外]*)孙/,
    arr: ['$1甥$2孙'],
  },
  {
    exp: /([孙甥侄])$/,
    arr: ['$1男', '$1女'],
  },
  {
    exp: /([姑舅姨叔])([孙外]*)([男女])$/,
    arr: ['$1表侄$2$3', '$1表甥$2$3'],
  },
  {
    exp: /(.+)父母$/,
    arr: ['$1父', '$1母'],
  },
  {
    exp: /(.+)公婆$/,
    arr: ['$1公', '$1婆'],
  },
  {
    exp: /祖$/,
    arr: ['祖父'],
  },
  {
    exp: /(新妇|媳)$/,
    arr: ['媳妇'],
  },
  {
    exp: /嫂$/,
    arr: ['兄妇'],
  },
  {
    exp: /女儿$/,
    arr: ['女'],
  },
];

export default replaceRules;
